import type { RelationshipType } from '../../app/api/generated/client';

export const horizontalRelationships: RelationshipType[] = ['IS_SPOUSE_OF', 'IS_REGISTERED_PARTNER_OF', 'IS_DIVORCED_FROM'];
export const verticalRelationships: RelationshipType[] = ['IS_PARENT_OF'];

export const partnerNodeSize = {
    width: 132,
    height: 200,
};

export const connectorNodeSize = {
    width: 100,
    height: 25,
};

export const nodeSpacing = {
    x: 100,
    y: 150,
};

export const connectorNodeSpacer = 75;
